module.exports = __webpack_public_path__ + "img/1553862902.3bfe6c7a.jpg";